import { flagError } from 'error-handling'

// NOTE: This can't be moved to a composable since it depends on the useFetch performance optimizations
// TODO: Create a separate version for refresh-common

type RouteType = { path: string; query?: any; hash?: any; params?: any }

type ResponseResourceType = {
  resolved: any
  redirect: any
}

export const useGetResource = async (route: RouteType) => {
  const router = useRouter()

  const { data, error } = await useFetch<ResponseResourceType>(
    '/api/content?route=' + route.path + (route.query?.preview ? '&preview=true' : ''),
  )

  if (error.value?.data) {
    flagError(error.value?.data, 'useJsonApi/useGetResource')
    throw createError({
      statusCode: 404,
      fatal: true,
    })
  }

  if (data?.value?.redirect) {
    const redirectData = data.value.redirect.find((item: any) => item.from === route.path)

    if (redirectData) {
      // Local redirect
      if (!redirectData.to.includes('http')) {
        router.push({ path: redirectData.to, query: route.query, hash: route.hash })
      } else {
        // External redirect
        return { redirect: redirectData.to }
      }
    }
  }

  if (!data?.value) {
    throw createError({
      statusCode: 404,
      fatal: true,
    })
  }

  return data.value
}

export const useGetData = async () => {
  const config = useRuntimeConfig()
  const lang = config.public.siteLang || 'sv'

  const { data, error } = await useFetch<any>('/api/static')

  if (error.value?.data) {
    flagError(error.value?.data, 'useJsonApi/useGetData')
  }

  return {
    additionalData: data?.value?.[0]?.data?.[lang],
    footerData: data?.value?.[1]?.data?.[lang],
    primaryNav: data?.value?.[2],
  }
}
